function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function e(e, t) {
  for (var _r in e) {
    t(e[_r], _r);
  }
}

function t(e, t) {
  e.forEach(t);
}

function r(e, t) {
  if (!e) throw Error(t);
}

function n(e, t) {
  ue = {
    parent: ue,
    value: e,
    template: ne(e, 'template') || ce(),
    sidRoot: ne(e, 'sidRoot') || ue && ue.sidRoot
  };

  try {
    return t();
  } finally {
    ue = te(ue);
  }
}

function a() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$node = _ref.node,
      e = _ref$node === void 0 ? [] : _ref$node,
      r = _ref.from,
      n = _ref.source,
      _ref$parent = _ref.parent,
      a = _ref$parent === void 0 ? r || n : _ref$parent,
      o = _ref.to,
      l = _ref.target,
      _ref$child = _ref.child,
      i = _ref$child === void 0 ? o || l : _ref$child,
      _ref$scope = _ref.scope,
      s = _ref$scope === void 0 ? {} : _ref$scope,
      _ref$meta = _ref.meta,
      f = _ref$meta === void 0 ? {} : _ref$meta,
      _ref$family = _ref.family,
      u = _ref$family === void 0 ? {
    type: 'regular'
  } : _ref$family,
      c = _ref.regional;

  var d = ge(a),
      p = ge(u.links),
      m = ge(u.owners),
      g = [];
  t(e, function (e) {
    return e && G(g, e);
  });
  var h = {
    id: fe(),
    seq: g,
    next: ge(i),
    meta: f,
    scope: s,
    family: {
      type: u.type || "crosslink",
      links: p,
      owners: m
    }
  };
  return t(p, function (e) {
    return G(Q(e), h);
  }), t(m, function (e) {
    return G(X(e), h);
  }), t(d, function (e) {
    return G(e.next, h);
  }), c && ue && me(Z(ue), [h]), h;
}

function o(e, r, n) {
  var a = Xe,
      o = null,
      l = Ge;
  if (e.target && (r = e.params, n = e.defer, a = 'page' in e ? e.page : a, e.stack && (o = e.stack), l = re(e) || l, e = e.target), l && Ge && l !== Ge && (Ge = null), Array.isArray(e)) for (var _t = 0; _t < e.length; _t++) {
    Te('pure', a, K(e[_t]), o, r[_t], l);
  } else Te('pure', a, K(e), o, r, l);
  if (n && !Je) return;
  var i,
      s,
      f,
      u,
      c,
      d,
      p = {
    isRoot: Je,
    currentPage: Xe,
    scope: Ge,
    isWatch: Ke,
    isPure: Qe
  };
  Je = 0;

  var _loop = function _loop() {
    var _u = u,
        e = _u.idx,
        r = _u.stack,
        n = _u.type;
    f = r.node, Xe = c = r.page, Ge = re(r), c ? d = c.reg : Ge && (d = Ge.reg);
    var a = !!c,
        o = !!Ge,
        l = {
      fail: 0,
      scope: f.scope
    };
    i = s = 0;

    for (var _t2 = e; _t2 < f.seq.length && !i; _t2++) {
      var _u2 = f.seq[_t2];

      if (_u2.order) {
        var _u2$order = _u2.order,
            _a = _u2$order.priority,
            _o = _u2$order.barrierID,
            _l = _o ? c ? "".concat(c.fullID, "_").concat(_o) : _o : 0;

        if (_t2 !== e || n !== _a) {
          _o ? Ue.has(_l) || (Ue.add(_l), We(_t2, r, _a, _o)) : We(_t2, r, _a);
          return "continue|e";
        }

        _o && Ue.delete(_l);
      }

      switch (_u2.type) {
        case 'mov':
          {
            var _e3 = void 0,
                _t3 = _u2.data;

            switch (_t3.from) {
              case z:
                _e3 = Z(r);
                break;

              case "a":
              case 'b':
                _e3 = r[_t3.from];
                break;

              case "value":
                _e3 = _t3.store;
                break;

              case "store":
                if (d && !d[_t3.store.id]) if (a) {
                  var _e4 = et(c, _t3.store.id);

                  r.page = c = _e4, _e4 ? d = _e4.reg : o ? (rt(Ge, _t3.store, 0, 1, _t3.softRead), d = Ge.reg) : d = void 0;
                } else o && rt(Ge, _t3.store, 0, 1, _t3.softRead);
                _e3 = ze(d && d[_t3.store.id] || _t3.store);
            }

            switch (_t3.to) {
              case z:
                r.value = _e3;
                break;

              case "a":
              case 'b':
                r[_t3.to] = _e3;
                break;

              case "store":
                tt(c, Ge, f, _t3.target).current = _e3;
            }

            break;
          }

        case 'compute':
          var _e2 = _u2.data;

          if (_e2.fn) {
            Ke = 'watch' === ne(f, 'op'), Qe = _e2.pure;

            var _t4 = _e2.safe ? (0, _e2.fn)(Z(r), l.scope, r) : nt(l, _e2.fn, r);

            _e2.filter ? s = !_t4 : r.value = _t4, Ke = p.isWatch, Qe = p.isPure;
          }

      }

      i = l.fail || s;
    }

    if (!i) {
      var _e5 = Z(r);

      t(f.next, function (t) {
        Te('child', c, t, r, _e5, re(r));
      });

      var _n = re(r);

      if (_n) {
        ne(f, 'needFxCounter') && Te('child', c, _n.fxCount, r, _e5, _n), ne(f, 'storeChange') && Te('child', c, _n.storeChange, r, _e5, _n);
        var _a2 = _n.additionalLinks[f.id];
        _a2 && t(_a2, function (t) {
          Te('child', c, t, r, _e5, _n);
        });
      }
    }
  };

  e: for (; u = Le();) {
    var _ret = _loop();

    if (_ret === "continue|e") continue e;
  }

  Je = p.isRoot, Xe = p.currentPage, Ge = re(p);
}

function l(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "combine";
  var n = r + '(',
      a = '',
      o = 0;
  return e(t, function (e) {
    o < 25 && (null != e && (n += a, n += _(e) ? oe(e).fullName : e.toString()), o += 1, a = ', ');
  }), n + ')';
}

function i(e, t) {
  e.shortName = t, Object.assign(oe(e), s(t, te(e)));
}

function s(e, t) {
  var r,
      n,
      a = e;

  if (t) {
    var _a3 = oe(t);

    0 === e.length ? (r = _a3.path, n = _a3.fullName) : (r = _a3.path.concat([e]), n = 0 === _a3.fullName.length ? e : _a3.fullName + '/' + e);
  } else r = 0 === e.length ? [] : [e], n = e;

  return {
    shortName: a,
    fullName: n,
    path: r
  };
}

function f(e, t) {
  var r = t ? e : e[0];
  ve(r);
  var n = r.or,
      a = r.and;

  if (a) {
    var _r2 = t ? a : a[0];

    if (he(_r2) && 'and' in _r2) {
      var _r3 = f(a, t);

      e = _r3[0], n = _objectSpread(_objectSpread({}, n), _r3[1]);
    } else e = a;
  }

  return [e, n];
}

function u(e) {
  var r = ce();

  if (r) {
    var _n2 = r.handlers[e];

    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    if (_n2) return _n2.apply(void 0, [r].concat(t));
  }
}

function c(e, t) {
  var r = function r(e) {
    for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      t[_key2 - 1] = arguments[_key2];
    }

    return J(!ne(r, 'derived'), 'call of derived event', 'createEvent'), J(!Qe, 'unit call from pure function', 'operators like sample'), Xe ? function (e, t, r, n) {
      var a = Xe,
          o = null;
      if (t) for (o = Xe; o && o.template !== t;) {
        o = te(o);
      }
      Ze(o);
      var l = e.create(r, n);
      return Ze(a), l;
    }(r, n, e, t) : r.create(e, t);
  },
      n = ce();

  return Object.assign(r, {
    graphite: a({
      meta: gt("event", r, e, t),
      regional: 1
    }),
    create: function create(e) {
      return o({
        target: r,
        params: e,
        scope: Ge
      }), e;
    },
    watch: function watch(e) {
      return pt(r, e);
    },
    map: function map(e) {
      return yt(r, R, e, [Fe()]);
    },
    filter: function filter(e) {
      return yt(r, "filter", e.fn ? e : e.fn, [Fe(Ce, 1)]);
    },
    filterMap: function filterMap(e) {
      return yt(r, 'filterMap', e, [Fe(), Ne(function (e) {
        return !be(e);
      }, 1)]);
    },
    prepend: function prepend(e) {
      var t = c("* \u2192 " + r.shortName, {
        parent: te(r)
      });
      return u('eventPrepend', K(t)), ct(t, r, [Fe()], 'prepend', e), mt(r, t), t;
    }
  });
}

function d(e, n) {
  var l = Re(e),
      i = ht('updates');
  u('storeBase', l);
  var s = l.id,
      f = {
    subscribers: new Map(),
    updates: i,
    defaultState: e,
    stateRef: l,
    getState: function getState() {
      var e,
          t = l;

      if (Xe) {
        var _t5 = Xe;

        for (; _t5 && !_t5.reg[s];) {
          _t5 = te(_t5);
        }

        _t5 && (e = _t5);
      }

      return !e && Ge && (rt(Ge, l, 1), e = Ge), e && (t = e.reg[s]), ze(t);
    },
    setState: function setState(e) {
      return o({
        target: f,
        params: e,
        defer: 1,
        scope: Ge
      });
    },
    reset: function reset() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }

      return t(e, function (e) {
        return f.on(e, function () {
          return f.defaultState;
        });
      }), f;
    },
    on: function on(e, r) {
      return we(e, '.on', 'first argument'), J(!ne(f, 'derived'), '.on in derived store', 'createStore'), t(Array.isArray(e) ? e : [e], function (e) {
        f.off(e), ee(f).set(e, ut(bt(e, f, 'on', $e, r)));
      }), f;
    },
    off: function off(e) {
      var t = ee(f).get(e);
      return t && (t(), ee(f).delete(e)), f;
    },
    map: function map(e, t) {
      var r, n;
      he(e) && (r = e, e = e.fn), J(be(t), 'second argument of store.map', 'updateFilter');
      var a = f.getState();
      ce() ? n = null : be(a) || (n = e(a, t));
      var o = d(n, {
        name: "".concat(f.shortName, " \u2192 *"),
        derived: 1,
        and: r
      }),
          i = bt(f, o, R, Se, e);
      return _e(Y(o), {
        type: R,
        fn: e,
        from: l
      }), Y(o).noInit = 1, u('storeMap', l, i), o;
    },
    watch: function watch(e, t) {
      if (!t || !_(e)) {
        var _t6 = pt(f, e);

        return u('storeWatch', l, e) || e(f.getState()), _t6;
      }

      return r(ye(t), 'second argument should be a function'), e.watch(function (e) {
        return t(f.getState(), e);
      });
    }
  },
      c = gt("store", f, n),
      p = f.defaultConfig.updateFilter;
  f.graphite = a({
    scope: {
      state: l,
      fn: p
    },
    node: [Ne(function (e, t, r) {
      return r.scope && !r.scope.reg[l.id] && (r.b = 1), e;
    }), Oe(l), Ne(function (e, t, _ref2) {
      var r = _ref2.a,
          n = _ref2.b;
      return !be(e) && (e !== r || n);
    }, 1), p && Fe(Se, 1), Ae({
      from: z,
      target: l
    })],
    child: i,
    meta: c,
    regional: 1
  });
  var m = ne(f, 'sid');
  return m && ('ignore' !== ne(f, 'serialize') && ae(f, 'storeChange', 1), l.sid = m), r(ne(f, 'derived') || !be(e), "current state can't be undefined, use null instead"), me(f, [i]), f;
}

function p() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }

  var t, n, a;

  var _f = f(e);

  var _f2 = _slicedToArray(_f, 2);

  e = _f2[0];
  a = _f2[1];
  var o,
      l,
      i,
      s = e[e.length - 1];

  if (ye(s) ? (n = e.slice(0, -1), t = s) : n = e, 1 === n.length) {
    var _e6 = n[0];
    V(_e6) || (o = _e6, l = 1);
  }

  if (!l && (o = n, t)) {
    i = 1;
    var _e7 = t;

    t = function t(_t7) {
      return _e7.apply(void 0, _toConsumableArray(_t7));
    };
  }

  return r(he(o), 'shape should be an object'), vt(Array.isArray(o), !i, o, a, t);
}

function m() {
  return J(0, 'createStoreObject', 'combine'), p.apply(void 0, arguments);
}

function g() {
  var e = {};
  return e.req = new Promise(function (t, r) {
    e.rs = t, e.rj = r;
  }), e.req.catch(function () {}), e;
}

function h(e, t) {
  var n = c(ye(e) ? {
    handler: e
  } : e, t),
      l = K(n);
  ae(l, 'op', n.kind = "effect"), n.use = function (e) {
    return r(ye(e), '.use argument should be a function'), m.scope.handler = e, n;
  }, n.use.getCurrent = function () {
    return m.scope.handler;
  };
  var i = n.finally = ht('finally'),
      s = n.done = i.filterMap({
    named: 'done',
    fn: function fn(_ref3) {
      var e = _ref3.status,
          t = _ref3.params,
          r = _ref3.result;
      if ('done' === e) return {
        params: t,
        result: r
      };
    }
  }),
      f = n.fail = i.filterMap({
    named: 'fail',
    fn: function fn(_ref4) {
      var e = _ref4.status,
          t = _ref4.params,
          r = _ref4.error;
      if ('fail' === e) return {
        params: t,
        error: r
      };
    }
  }),
      u = n.doneData = s.map({
    named: 'doneData',
    fn: function fn(_ref5) {
      var e = _ref5.result;
      return e;
    }
  }),
      p = n.failData = f.map({
    named: 'failData',
    fn: function fn(_ref6) {
      var e = _ref6.error;
      return e;
    }
  }),
      m = a({
    scope: {
      handlerId: ne(l, 'sid'),
      handler: n.defaultConfig.handler || function () {
        return r(0, "no handler used in ".concat(n.getType()));
      }
    },
    node: [Ne(function (e, t, r) {
      var n = t,
          a = n.handler;

      if (re(r)) {
        var _e8 = re(r).handlers[n.handlerId];
        _e8 && (a = _e8);
      }

      return e.handler = a, e;
    }, 0, 1), Ne(function (_ref7, a, o) {
      var e = _ref7.params,
          t = _ref7.req,
          r = _ref7.handler,
          _ref7$args = _ref7.args,
          n = _ref7$args === void 0 ? [e] : _ref7$args;

      var l = wt(e, t, 1, i, o),
          s = wt(e, t, 0, i, o),
          _kt = kt(r, s, n),
          _kt2 = _slicedToArray(_kt, 2),
          f = _kt2[0],
          u = _kt2[1];

      f && (he(u) && ye(u.then) ? u.then(l, s) : l(u));
    }, 0, 1)],
    meta: {
      op: 'fx',
      fx: 'runner'
    }
  });
  l.scope.runner = m, G(l.seq, Ne(function (e, _ref8, r) {
    var t = _ref8.runner;
    var n = te(r) ? {
      params: e,
      req: {
        rs: function rs(e) {},
        rj: function rj(e) {}
      }
    } : e;
    return o({
      target: t,
      params: n,
      defer: 1,
      scope: re(r)
    }), n.params;
  }, 0, 1)), n.create = function (e) {
    var t = g(),
        r = {
      params: e,
      req: t
    };

    if (Ge) {
      if (!Ke) {
        var _e9 = Ge;
        t.req.finally(function () {
          Ye(_e9);
        }).catch(function () {});
      }

      o({
        target: n,
        params: r,
        scope: Ge
      });
    } else o(n, r);

    return t.req;
  };
  var h = n.inFlight = d(0, {
    named: 'inFlight'
  }).on(n, function (e) {
    return e + 1;
  }).on(i, function (e) {
    return e - 1;
  });
  ae(i, 'needFxCounter', 'dec'), ae(n, 'needFxCounter', 1);
  var y = n.pending = h.map({
    fn: function fn(e) {
      return e > 0;
    },
    named: 'pending'
  });
  return me(n, [i, s, f, u, p, y, h]), n;
}

function y(e) {
  var _u$seq;

  var t;

  var _f3 = f(e, 1);

  var _f4 = _slicedToArray(_f3, 2);

  e = _f4[0];
  t = _f4[1];
  var _e10 = e,
      r = _e10.source,
      n = _e10.effect,
      a = _e10.mapParams,
      l = h(e, t);
  ae(l, 'attached', 1);
  var i,
      u = K(l).scope.runner,
      c = Ne(function (e, t, n) {
    var _kt3, _kt4;

    var i,
        s = e.params,
        f = e.req,
        u = e.handler,
        c = l.finally,
        d = wt(s, f, 0, c, n),
        p = n.a,
        m = B(u),
        g = 1;

    if (a ? (_kt3 = kt(a, d, [s, p]), _kt4 = _slicedToArray(_kt3, 2), g = _kt4[0], i = _kt4[1], _kt3) : i = r && m ? p : s, g) {
      if (!m) return e.args = [p, i], 1;
      o({
        target: u,
        params: {
          params: i,
          req: {
            rs: wt(s, f, 1, c, n),
            rj: d
          }
        },
        page: n.page,
        defer: 1
      });
    }
  }, 1, 1);

  if (r) {
    var _e11;

    V(r) ? (_e11 = r, me(_e11, [l])) : (_e11 = p(r), me(l, [_e11])), i = [Oe(Y(_e11)), c];
  } else i = [c];

  (_u$seq = u.seq).splice.apply(_u$seq, [1, 0].concat(_toConsumableArray(i))), l.use(n);
  var d = te(n);
  return d && (Object.assign(oe(l), s(l.shortName, d)), l.defaultConfig.parent = d), mt(n, l, "effect"), l;
}

function b() {
  for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    t[_key5] = arguments[_key5];
  }

  var _f5 = f(t),
      _f6 = _slicedToArray(_f5, 2),
      _f6$ = _slicedToArray(_f6[0], 2),
      r = _f6$[0],
      n = _f6$[1],
      a = _f6[1],
      o = {};

  return e(n, function (e, t) {
    var n = o[t] = c(t, {
      parent: te(r),
      config: a
    });
    r.on(n, e), mt(r, n);
  }), o;
}

function v(r, n) {
  var l = a({
    family: {
      type: "domain"
    },
    regional: 1
  }),
      i = {
    history: {},
    graphite: l,
    hooks: {}
  };
  l.meta = gt("domain", i, r, n), e({
    Event: c,
    Effect: h,
    Store: d,
    Domain: v
  }, function (e, r) {
    var n = r.toLowerCase(),
        a = ht("on".concat(r));
    i.hooks[n] = a;
    var l = new Set();
    i.history["".concat(n, "s")] = l, a.create = function (e) {
      return o(a, e), e;
    }, G(K(a).seq, Ne(function (e, t, r) {
      return r.scope = null, e;
    })), a.watch(function (e) {
      me(i, [e]), l.add(e), e.ownerSet || (e.ownerSet = l), te(e) || (e.parent = i);
    }), me(i, [a]), i["onCreate".concat(r)] = function (e) {
      return t(l, e), a.watch(e);
    }, i["create".concat(r)] = i[n] = function (t, r) {
      return a(e(t, {
        parent: i,
        or: r
      }));
    };
  });
  var s = te(i);
  return s && e(i.hooks, function (e, t) {
    return ct(e, s.hooks[t]);
  }), i;
}

function k(e) {
  ve(e);
  var t = D in e ? e[D]() : e;
  r(t.subscribe, 'expect observable to have .subscribe');
  var n = c(),
      a = ut(n);
  return t.subscribe({
    next: n,
    error: a,
    complete: a
  }), n;
}

function w(e, t) {
  we(e, 'merge', 'first argument');
  var r = c({
    name: l(e, 'merge'),
    derived: 1,
    and: t
  });
  return ct(e, r, [], 'merge'), r;
}

function x(e, n) {
  var a = 0;
  return t(St, function (t) {
    t in e && (r(null != e[t], $t(n, t)), a = 1);
  }), a;
}

function S() {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }

  var t,
      r,
      n,
      a,
      _f7 = f(e),
      _f8 = _slicedToArray(_f7, 2),
      _f8$ = _slicedToArray(_f8[0], 3),
      o = _f8$[0],
      l = _f8$[1],
      i = _f8$[2],
      s = _f8[1],
      u = 1;

  return be(l) && he(o) && x(o, "sample") && (l = o.clock, i = o.fn, u = !o.greedy, a = o.filter, t = o.target, r = o.name, n = o.sid, o = o.source), Ct("sample", l, o, a, t, i, r, s, u, 1, 0, n);
}

function $() {
  for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    e[_key7] = arguments[_key7];
  }

  var _f9 = f(e),
      _f10 = _slicedToArray(_f9, 2),
      _f10$ = _slicedToArray(_f10[0], 2),
      t = _f10$[0],
      r = _f10$[1],
      n = _f10[1];

  return r || (r = t, t = r.source), x(r, 'guard'), Ct('guard', r.clock, t, r.filter, r.target, null, r.name, n, !r.greedy, 0, 1);
}

function C(t, r, n) {
  if (V(t)) return J(0, 'restore($store)'), t;

  if (E(t) || B(t)) {
    var _e12 = te(t),
        _a4 = d(r, {
      parent: _e12,
      name: t.shortName,
      and: n
    });

    return ct(B(t) ? t.doneData : t, _a4), _e12 && _e12.hooks.store(_a4), _a4;
  }

  var a = Array.isArray(t) ? [] : {};
  return e(t, function (e, t) {
    return a[t] = V(e) ? e : d(e, {
      name: t
    });
  }), a;
}

function M() {
  for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    t[_key8] = arguments[_key8];
  }

  var n,
      o,
      l = 'split',
      _f11 = f(t),
      _f12 = _slicedToArray(_f11, 2),
      _f12$ = _slicedToArray(_f12[0], 2),
      i = _f12$[0],
      s = _f12$[1],
      d = _f12[1],
      p = !s;

  p && (n = i.cases, s = i.match, o = i.clock, i = i.source);
  var m = V(s),
      g = !_(s) && ye(s),
      h = !m && !g && he(s);
  n || (n = {}), p ? e(n, function (e, t) {
    return xe(l, e, "cases.".concat(t));
  }) : (r(h, 'match should be an object'), e(s, function (e, t) {
    return n[t] = c({
      derived: 1,
      and: d
    });
  }), n.__ = c({
    derived: 1,
    and: d
  }));
  var y,
      b = new Set([].concat(i, o || [], Object.values(n))),
      v = Object.keys(m || g ? n : s);
  if (m || g) m && b.add(s), y = [m && Oe(Y(s), 0, 1), Ie({
    safe: m,
    filter: 1,
    pure: !m,
    fn: function fn(e, t, r) {
      var n = String(m ? r.a : s(e));
      At(t, H(v, n) ? n : '__', e, r);
    }
  })];else if (h) {
    var _t8 = Re({});

    _t8.type = 'shape';

    var _r4,
        _n3 = [];

    e(s, function (e, a) {
      if (_(e)) {
        _r4 = 1, G(_n3, a), b.add(e);

        var _o2 = ct(e, [], [Oe(_t8), Ne(function (e, t, _ref9) {
          var r = _ref9.a;
          return r[a] = e;
        })]);

        if (V(e)) {
          _t8.current[a] = e.getState();

          var _r5 = Y(e);

          _e(_t8, {
            from: _r5,
            field: a,
            type: 'field'
          }), u('splitMatchStore', _r5, _o2);
        }
      }
    }), _r4 && u('splitBase', _t8), y = [_r4 && Oe(_t8, 0, 1), Fe(function (e, t, r) {
      for (var _a5 = 0; _a5 < v.length; _a5++) {
        var _o3 = v[_a5];
        if (H(_n3, _o3) ? r.a[_o3] : s[_o3](e)) return void At(t, _o3, e, r);
      }

      At(t, '__', e, r);
    }, 1)];
  } else r(0, 'expect match to be unit, function or object');
  var k = a({
    meta: {
      op: l
    },
    parent: o ? [] : i,
    scope: n,
    node: y,
    family: {
      owners: Array.from(b)
    },
    regional: 1
  });
  if (o && Ct(l, o, i, null, k, null, l, d, 0, 0, 0), !p) return n;
}

function j(e, _ref10) {
  var t = _ref10.scope,
      r = _ref10.params;
  if (!_(e)) return Promise.reject(Error('first argument should be unit'));
  var n = g();
  n.parentFork = Ge;
  var a = t.fxCount;
  G(a.scope.defers, n);
  var l = [e],
      i = [];
  return G(i, B(e) ? {
    params: r,
    req: {
      rs: function rs(e) {
        n.value = {
          status: 'done',
          value: e
        };
      },
      rj: function rj(e) {
        n.value = {
          status: 'fail',
          value: e
        };
      }
    }
  } : r), G(l, a), G(i, null), o({
    target: l,
    params: i,
    scope: t
  }), n.req;
}

function A(e, r) {
  var n = [];

  (function e(a) {
    H(n, a) || (G(n, a), "store" === ne(a, 'op') && ne(a, 'sid') && r(a, ne(a, 'sid')), t(a.next, e), t(Q(a), e), t(X(a), e));
  })(e);
}

function I(e, n) {
  if (Array.isArray(e) && (e = new Map(e)), e instanceof Map) {
    var _a6 = {};
    return t(e, function (e, t) {
      r(_(t), 'Map key should be a unit'), n && n(t, e), r(t.sid, 'unit should have a sid'), r(!(t.sid in _a6), 'duplicate sid found'), _a6[t.sid] = e;
    }), _a6;
  }

  return e;
}

function q(e, n) {
  var o,
      l = e;
  L(e) && (o = e, l = n);

  var i = function (e) {
    var r = a({
      scope: {
        defers: [],
        inFlight: 0,
        fxID: 0
      },
      node: [Ne(function (e, t, r) {
        te(r) ? 'dec' === ne(te(r).node, 'needFxCounter') ? t.inFlight -= 1 : (t.inFlight += 1, t.fxID += 1) : t.fxID += 1;
      }), Ie({
        priority: "sampler",
        batch: 1
      }), Ne(function (e, r) {
        var n = r.defers,
            a = r.fxID;
        r.inFlight > 0 || 0 === n.length || Promise.resolve().then(function () {
          r.fxID === a && t(n.splice(0, n.length), function (e) {
            Ye(e.parentFork), e.rs(e.value);
          });
        });
      }, 0, 1)]
    }),
        n = a({
      node: [Ne(function (e, t, r) {
        var n = te(r);

        if (n && te(n)) {
          var _t9 = n.node;

          if (!ne(_t9, 'isCombine') || 'combine' !== ne(te(n).node, 'op')) {
            var _n4 = re(r),
                _a7 = _t9.scope.state.id,
                _o4 = ne(_t9, 'sid');

            _n4.sidIdMap[_o4] = _a7, _n4.sidValuesMap[_o4] = e;
          }
        }
      })]
    }),
        o = {
      cloneOf: e,
      reg: {},
      sidValuesMap: {},
      sidIdMap: {},
      getState: function getState(e) {
        if ('current' in e) return tt(Xe, o, null, e).current;
        var t = K(e);
        return tt(Xe, o, t, t.scope.state, 1).current;
      },
      kind: "scope",
      graphite: a({
        family: {
          type: "domain",
          links: [r, n]
        },
        meta: {
          unit: 'fork'
        },
        scope: {
          forkInFlightCounter: r
        }
      }),
      additionalLinks: {},
      handlers: {},
      fxCount: r,
      storeChange: n
    };
    return o;
  }(o);

  if (l) {
    if (l.values) {
      var _e13 = I(l.values, function (e) {
        return r(V(e), 'Values map can contain only stores as keys');
      });

      Object.assign(i.sidValuesMap, _e13);
    }

    l.handlers && (i.handlers = I(l.handlers, function (e) {
      return r(B(e), "Handlers map can contain only effects as keys");
    }));
  }

  return i;
}

function N(e, _ref11) {
  var t = _ref11.values;
  r(he(t), 'values property should be an object');
  var n,
      a,
      l,
      i = I(t),
      s = Object.getOwnPropertyNames(i),
      f = [],
      u = [];
  T(e) ? (n = e, l = 1, r(n.cloneOf, 'scope should be created from domain'), a = K(n.cloneOf)) : L(e) ? a = K(e) : r(0, 'first argument of hydrate should be domain or scope'), A(a, function (e, t) {
    H(s, t) && (G(f, e), G(u, i[t]));
  }), o({
    target: f,
    params: u,
    scope: n
  }), l && Object.assign(n.sidValuesMap, i);
}

function O(e) {
  var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref12.scope;

  r(t || Ge, 'scopeBind cannot be called outside of forked .watch');
  var n = t || Ge;
  return B(e) ? function (t) {
    var r = g();
    return o({
      target: e,
      params: {
        params: t,
        req: r
      },
      scope: n
    }), r.req;
  } : function (t) {
    return o({
      target: e,
      params: t,
      scope: n
    }), t;
  };
}

function F(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var a = n.ignore ? n.ignore.map(function (_ref13) {
    var e = _ref13.sid;
    return e;
  }) : [],
      o = {};
  return e(t.sidValuesMap, function (e, r) {
    if (H(a, r)) return;
    var n = t.sidIdMap[r];
    o[r] = n && n in t.reg ? t.reg[n].current : e;
  }), 'onlyChanges' in n && !n.onlyChanges && (r(t.cloneOf, 'scope should be created from domain'), A(K(t.cloneOf), function (e, r) {
    r in o || H(a, r) || ne(e, 'isCombine') || 'ignore' === ne(e, 'serialize') || (o[r] = t.getState(e));
  })), o;
}

var D = 'undefined' != typeof Symbol && Symbol.observable || '@@observable',
    R = 'map',
    z = 'stack',
    _ = function _(e) {
  return (ye(e) || he(e)) && 'kind' in e;
};

var P = function P(e) {
  return function (t) {
    return _(t) && t.kind === e;
  };
};

var V = P("store"),
    E = P("event"),
    B = P("effect"),
    L = P("domain"),
    T = P("scope");
var W = {
  __proto__: null,
  unit: _,
  store: V,
  event: E,
  effect: B,
  domain: L,
  scope: T
};

var H = function H(e, t) {
  return e.includes(t);
},
    U = function U(e, t) {
  var r = e.indexOf(t);
  -1 !== r && e.splice(r, 1);
},
    G = function G(e, t) {
  return e.push(t);
},
    J = function J(e, t, r) {
  return !e && console.error("".concat(t, " is deprecated").concat(r ? ", use ".concat(r, " instead") : ''));
},
    K = function K(e) {
  return e.graphite || e;
},
    Q = function Q(e) {
  return e.family.owners;
},
    X = function X(e) {
  return e.family.links;
},
    Y = function Y(e) {
  return e.stateRef;
},
    Z = function Z(e) {
  return e.value;
},
    ee = function ee(e) {
  return e.subscribers;
},
    te = function te(e) {
  return e.parent;
},
    re = function re(e) {
  return e.scope;
},
    ne = function ne(e, t) {
  return K(e).meta[t];
},
    ae = function ae(e, t, r) {
  return K(e).meta[t] = r;
},
    oe = function oe(e) {
  return e.compositeName;
};

var le = function le() {
  var e = 0;
  return function () {
    return "" + ++e;
  };
};

var ie = le(),
    se = le(),
    fe = le(),
    ue = null,
    ce = function ce() {
  return ue && ue.template;
},
    de = function de(e) {
  return e && ue && ue.sidRoot && (e = "".concat(ue.sidRoot, "|").concat(e)), e;
},
    pe = function pe(_ref14) {
  var e = _ref14.sid,
      t = _ref14.name,
      r = _ref14.loc,
      o = _ref14.method,
      l = _ref14.fn;
  return n(a({
    meta: {
      sidRoot: de(e),
      name: t,
      loc: r,
      method: o
    }
  }), l);
},
    me = function me(e, r) {
  var n = K(e);
  t(r, function (e) {
    var t = K(e);
    "domain" !== n.family.type && (t.family.type = "crosslink"), G(Q(t), n), G(X(n), t);
  });
},
    ge = function ge() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (Array.isArray(e) ? e : [e]).flat().map(K);
},
    he = function he(e) {
  return 'object' == _typeof(e) && null !== e;
},
    ye = function ye(e) {
  return 'function' == typeof e;
},
    be = function be(e) {
  return void 0 === e;
},
    ve = function ve(e) {
  return r(he(e) || ye(e), 'expect first argument be an object');
};

var ke = function ke(e, t, n, a) {
  return r(!(!he(e) && !ye(e) || !('family' in e) && !('graphite' in e)), "".concat(t, ": expect ").concat(n, " to be a unit (store, event or effect)").concat(a));
};

var we = function we(e, r, n) {
  Array.isArray(e) ? t(e, function (e, t) {
    return ke(e, r, "".concat(t, " item of ").concat(n), '');
  }) : ke(e, r, n, ' or array of units');
},
    xe = function xe(e, r) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "target";
  return t(ge(r), function (t) {
    return J(!ne(t, 'derived'), "".concat(e, ": derived unit in \"").concat(n, "\""), "createEvent/createStore");
  });
},
    Se = function Se(e, _ref15, _ref16) {
  var t = _ref15.fn;
  var r = _ref16.a;
  return t(e, r);
},
    $e = function $e(e, _ref17, _ref18) {
  var t = _ref17.fn;
  var r = _ref18.a;
  return t(r, e);
},
    Ce = function Ce(e, _ref19) {
  var t = _ref19.fn;
  return t(e);
};

var Me = function Me(e, t, r, n) {
  var a = {
    id: se(),
    type: e,
    data: t
  };
  return r && (a.order = {
    priority: r
  }, n && (a.order.barrierID = ++je)), a;
};

var je = 0,
    Ae = function Ae(_ref20) {
  var _ref20$from = _ref20.from,
      e = _ref20$from === void 0 ? "store" : _ref20$from,
      t = _ref20.store,
      r = _ref20.target,
      _ref20$to = _ref20.to,
      n = _ref20$to === void 0 ? r ? "store" : z : _ref20$to,
      a = _ref20.batch,
      o = _ref20.priority;
  return Me('mov', {
    from: e,
    store: t,
    to: n,
    target: r
  }, o, a);
},
    Ie = function Ie(_ref21) {
  var e = _ref21.fn,
      t = _ref21.batch,
      r = _ref21.priority,
      _ref21$safe = _ref21.safe,
      n = _ref21$safe === void 0 ? 0 : _ref21$safe,
      _ref21$filter = _ref21.filter,
      a = _ref21$filter === void 0 ? 0 : _ref21$filter,
      _ref21$pure = _ref21.pure,
      o = _ref21$pure === void 0 ? 0 : _ref21$pure;
  return Me('compute', {
    fn: e,
    safe: n,
    filter: a,
    pure: o
  }, r, t);
},
    qe = function qe(_ref22) {
  var e = _ref22.fn;
  return Ie({
    fn: e,
    priority: "effect"
  });
},
    Ne = function Ne(e, t, r) {
  return Ie({
    fn: e,
    safe: 1,
    filter: t,
    priority: r && "effect"
  });
},
    Oe = function Oe(e, t, r) {
  return Ae({
    store: e,
    to: t ? z : "a",
    priority: r && "sampler",
    batch: 1
  });
},
    Fe = function Fe() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Ce;
  var t = arguments.length > 1 ? arguments[1] : undefined;
  return Ie({
    fn: e,
    pure: 1,
    filter: t
  });
},
    De = {
  mov: Ae,
  compute: Ie,
  filter: function filter(_ref23) {
    var e = _ref23.fn,
        t = _ref23.pure;
    return Ie({
      fn: e,
      filter: 1,
      pure: t
    });
  },
  run: qe
},
    Re = function Re(e) {
  return {
    id: se(),
    current: e
  };
},
    ze = function ze(_ref24) {
  var e = _ref24.current;
  return e;
},
    _e = function _e(e, t) {
  e.before || (e.before = []), G(e.before, t);
},
    Pe = null;

var Ve = function Ve(e, t) {
  if (!e) return t;
  if (!t) return e;
  var r;
  return (e.v.type === t.v.type && e.v.id > t.v.id || He(e.v.type) > He(t.v.type)) && (r = e, e = t, t = r), r = Ve(e.r, t), e.r = e.l, e.l = r, e;
},
    Ee = [];

var Be = 0;

for (; Be < 6;) {
  G(Ee, {
    first: null,
    last: null,
    size: 0
  }), Be += 1;
}

var Le = function Le() {
  for (var _e14 = 0; _e14 < 6; _e14++) {
    var _t10 = Ee[_e14];

    if (_t10.size > 0) {
      if (3 === _e14 || 4 === _e14) {
        _t10.size -= 1;
        var _e15 = Pe.v;
        return Pe = Ve(Pe.l, Pe.r), _e15;
      }

      1 === _t10.size && (_t10.last = null);
      var _r6 = _t10.first;
      return _t10.first = _r6.r, _t10.size -= 1, _r6.v;
    }
  }
},
    Te = function Te(e, t, r, n, a, o) {
  return We(0, {
    a: null,
    b: null,
    node: r,
    parent: n,
    value: a,
    page: t,
    scope: o
  }, e);
},
    We = function We(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var a = He(r),
      o = Ee[a],
      l = {
    v: {
      idx: e,
      stack: t,
      type: r,
      id: n
    },
    l: null,
    r: null
  };
  3 === a || 4 === a ? Pe = Ve(Pe, l) : (0 === o.size ? o.first = l : o.last.r = l, o.last = l), o.size += 1;
},
    He = function He(e) {
  switch (e) {
    case 'child':
      return 0;

    case 'pure':
      return 1;

    case 'read':
      return 2;

    case "barrier":
      return 3;

    case "sampler":
      return 4;

    case "effect":
      return 5;

    default:
      return -1;
  }
},
    Ue = new Set();

var Ge,
    Je = 1,
    Ke = 0,
    Qe = 0,
    Xe = null,
    Ye = function Ye(e) {
  Ge = e;
},
    Ze = function Ze(e) {
  Xe = e;
};

var et = function et(e, t) {
  if (e) {
    for (; e && !e.reg[t];) {
      e = te(e);
    }

    if (e) return e;
  }

  return null;
};

var tt = function tt(e, t, r, n, a) {
  var o = et(e, n.id);
  return o ? o.reg[n.id] : t ? (rt(t, n, a), t.reg[n.id]) : n;
},
    rt = function rt(e, r, n, a, o) {
  var l = e.reg,
      i = r.sid;
  if (l[r.id]) return;
  var s = {
    id: r.id,
    current: r.current
  };
  if (i && i in e.sidValuesMap && !(i in e.sidIdMap)) s.current = e.sidValuesMap[i];else if (r.before && !o) {
    var _o5 = 0,
        _i2 = n || !r.noInit || a;

    t(r.before, function (t) {
      switch (t.type) {
        case R:
          {
            var _r7 = t.from;

            if (_r7 || t.fn) {
              _r7 && rt(e, _r7, n, a);

              var _o6 = _r7 && l[_r7.id].current;

              _i2 && (s.current = t.fn ? t.fn(_o6) : _o6);
            }

            break;
          }

        case 'field':
          _o5 || (_o5 = 1, s.current = Array.isArray(s.current) ? _toConsumableArray(s.current) : _objectSpread({}, s.current)), rt(e, t.from, n, a), _i2 && (s.current[t.field] = l[l[t.from.id].id].current);
      }
    });
  }
  i && (e.sidIdMap[i] = r.id), l[r.id] = s;
};

var nt = function nt(e, t, r) {
  try {
    return t(Z(r), e.scope, r);
  } catch (t) {
    console.error(t), e.fail = 1;
  }
};

var at = function at(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return he(t) && (at(t.or, r), e(t, function (e, t) {
    be(e) || 'or' === t || 'and' === t || (r[t] = e);
  }), at(t.and, r)), r;
};

var ot = function ot(e, t) {
  U(e.next, t), U(Q(e), t), U(X(e), t);
},
    lt = function lt(e, t, r) {
  var n;
  e.next.length = 0, e.seq.length = 0, e.scope = null;
  var a = X(e);

  for (; n = a.pop();) {
    ot(n, e), (t || r && 'sample' !== ne(e, 'op') || "crosslink" === n.family.type) && lt(n, t, 'on' !== ne(n, 'op') && r);
  }

  for (a = Q(e); n = a.pop();) {
    ot(n, e), r && "crosslink" === n.family.type && lt(n, t, 'on' !== ne(n, 'op') && r);
  }
},
    st = function st(e) {
  return e.clear();
};

var ft = function ft(e) {
  var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref25.deep;

  var r = 0;
  if (e.ownerSet && e.ownerSet.delete(e), V(e)) st(ee(e));else if (L(e)) {
    r = 1;
    var _t11 = e.history;
    st(_t11.events), st(_t11.effects), st(_t11.stores), st(_t11.domains);
  }
  lt(K(e), !!t, r);
},
    ut = function ut(e) {
  var t = function t() {
    return ft(e);
  };

  return t.unsubscribe = t, t;
},
    ct = function ct(e, t, r, n, o) {
  return a({
    node: r,
    parent: e,
    child: t,
    scope: {
      fn: o
    },
    meta: {
      op: n
    },
    family: {
      owners: [e, t],
      links: t
    },
    regional: 1
  });
},
    dt = function dt(e) {
  var t = 'forward',
      _f13 = f(e, 1),
      _f14 = _slicedToArray(_f13, 2),
      _f14$ = _f14[0],
      r = _f14$.from,
      n = _f14$.to,
      o = _f14[1];

  return we(r, t, '"from"'), we(n, t, '"to"'), xe(t, n, 'to'), ut(a({
    parent: r,
    child: n,
    meta: {
      op: t,
      config: o
    },
    family: {},
    regional: 1
  }));
},
    pt = function pt(e, t) {
  return r(ye(t), '.watch argument should be a function'), ut(a({
    scope: {
      fn: t
    },
    node: [qe({
      fn: Ce
    })],
    parent: e,
    meta: {
      op: 'watch'
    },
    family: {
      owners: e
    },
    regional: 1
  }));
},
    mt = function mt(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "event";
  te(e) && te(e).hooks[r](t);
},
    gt = function gt(e, t, r, n) {
  var a = "domain" === e,
      o = ie(),
      l = at({
    or: n,
    and: 'string' == typeof r ? {
      name: r
    } : r
  }),
      _l$parent = l.parent,
      i = _l$parent === void 0 ? null : _l$parent,
      _l$sid = l.sid,
      f = _l$sid === void 0 ? null : _l$sid,
      _l$named = l.named,
      u = _l$named === void 0 ? null : _l$named,
      c = u || l.name || (a ? '' : o),
      d = s(c, i),
      p = {
    op: t.kind = e,
    name: t.shortName = c,
    sid: t.sid = de(f),
    named: u,
    unitId: t.id = o,
    serialize: l.serialize,
    derived: l.derived,
    config: l
  };

  if (t.parent = i, t.compositeName = d, t.defaultConfig = l, t.thru = function (e) {
    return J(0, 'thru', 'js pipe'), e(t);
  }, t.getType = function () {
    return d.fullName;
  }, !a) {
    t.subscribe = function (e) {
      return ve(e), t.watch(ye(e) ? e : function (t) {
        return e.next && e.next(t);
      });
    }, t[D] = function () {
      return t;
    };

    var _e16 = ce();

    _e16 && (p.nativeTemplate = _e16);
  }

  return p;
},
    ht = function ht(e) {
  return c({
    named: e
  });
};

var yt = function yt(e, t, r, n) {
  var a;
  he(r) && (a = r, r = r.fn);
  var o = c({
    name: "".concat(e.shortName, " \u2192 *"),
    derived: 1,
    and: a
  });
  return ct(e, o, n, t, r), o;
},
    bt = function bt(e, t, r, n, a) {
  var o = Y(t),
      l = Ae({
    store: o,
    to: "a",
    priority: 'read'
  });
  r === R && (l.data.softRead = 1);
  var i = [l, Fe(n)];
  return u('storeOnMap', o, i, V(e) && Y(e)), ct(e, t, i, r, a);
},
    vt = function vt(t, n, a, o, i) {
  var s = t ? function (e) {
    return e.slice();
  } : function (e) {
    return _objectSpread({}, e);
  },
      f = t ? [] : {},
      c = s(f),
      p = Re(c),
      m = Re(1);
  p.type = t ? 'list' : 'shape', p.noInit = 1, u('combineBase', p, m);
  var g = d(c, {
    name: l(a),
    derived: 1,
    and: o
  }),
      h = Y(g);
  h.noInit = 1, ae(g, 'isCombine', 1);
  var y = Oe(p);
  y.order = {
    priority: 'barrier'
  };
  var b = [Ne(function (e, t, r) {
    return r.scope && !r.scope.reg[p.id] && (r.c = 1), e;
  }), y, Ae({
    store: m,
    to: 'b'
  }), Ne(function (e, _ref26, r) {
    var t = _ref26.key;
    if (r.c || e !== r.a[t]) return n && r.b && (r.a = s(r.a)), r.a[t] = e, 1;
  }, 1), Ae({
    from: "a",
    target: p
  }), Ae({
    from: "value",
    store: 0,
    target: m
  }), Ae({
    from: "value",
    store: 1,
    target: m,
    priority: "barrier",
    batch: 1
  }), Oe(p, 1), i && Fe()];
  return e(a, function (e, t) {
    if (!V(e)) return r(!_(e) && !be(e), "combine expects a store in a field ".concat(t)), void (c[t] = f[t] = e);
    f[t] = e.defaultState, c[t] = e.getState();
    var n = ct(e, g, b, 'combine', i);
    n.scope.key = t;
    var a = Y(e);
    _e(p, {
      type: 'field',
      field: t,
      from: a
    }), u('combineField', a, n);
  }), g.defaultShape = a, _e(h, {
    type: R,
    from: p,
    fn: i
  }), ce() || (g.defaultState = i ? h.current = i(c) : f), g;
};

var kt = function kt(e, t, r) {
  try {
    return [1, e.apply(void 0, _toConsumableArray(r))];
  } catch (e) {
    return t(e), [0, null];
  }
},
    wt = function wt(e, t, r, n, a) {
  return function (l) {
    return o({
      target: [n, xt],
      params: [r ? {
        status: 'done',
        params: e,
        result: l
      } : {
        status: 'fail',
        params: e,
        error: l
      }, {
        value: l,
        fn: r ? t.rs : t.rj
      }],
      defer: 1,
      page: a.page,
      scope: re(a)
    });
  };
};

var xt = a({
  node: [qe({
    fn: function fn(_ref27) {
      var e = _ref27.fn,
          t = _ref27.value;
      return e(t);
    }
  })],
  meta: {
    op: 'fx',
    fx: 'sidechain'
  }
}),
    St = ['source', 'clock', 'target'],
    $t = function $t(e, t) {
  return e + ": ".concat(t, " should be defined");
};

var Ct = function Ct(e, t, n, a, o, l, i, s, f, m, g, h) {
  var y = !!o;
  r(!be(n) || !be(t), $t(e, 'either source or clock'));
  var b = 0;
  be(n) ? b = 1 : _(n) || (n = p(n)), be(t) ? t = n : (we(t, e, 'clock'), Array.isArray(t) && (t = w(t))), b && (n = t), s || i || (i = n.shortName);
  var v = 'none';
  (g || a) && (_(a) ? v = 'unit' : (r(ye(a), '`filter` should be function or unit'), v = 'fn')), o ? (we(o, e, 'target'), xe(e, o)) : 'none' === v && m && V(n) && V(t) ? o = d(l ? l(ze(Y(n)), ze(Y(t))) : ze(Y(n)), {
    name: i,
    sid: h,
    or: s
  }) : (o = c({
    name: i,
    derived: 1,
    or: s
  }), u('sampleTarget', K(o)));
  var k = Re(),
      x = [];

  if ('unit' === v) {
    var _jt = jt(a, o, t, k, e),
        _jt2 = _slicedToArray(_jt, 2),
        _r8 = _jt2[0],
        _n5 = _jt2[1];

    x = [].concat(_toConsumableArray(Mt(_n5)), _toConsumableArray(Mt(_r8)));
  }

  var _jt3 = jt(n, o, t, k, e),
      _jt4 = _slicedToArray(_jt3, 2),
      S = _jt4[0],
      $ = _jt4[1];

  return me(n, [ct(t, o, [u('sampleSourceLoader'), Ae({
    from: z,
    target: k
  })].concat(_toConsumableArray(Mt($)), [Oe(S, 1, f)], _toConsumableArray(x), [Oe(k), 'fn' === v && Fe(function (e, t, _ref28) {
    var r = _ref28.a;
    return a(e, r);
  }, 1), l && Fe(Se), u('sampleSourceUpward', y)]), e, l)]), o;
};

var Mt = function Mt(e) {
  return [Oe(e), Ne(function (e, t, _ref29) {
    var r = _ref29.a;
    return r;
  }, 1)];
},
    jt = function jt(e, t, r, n, o) {
  var l = V(e),
      i = l ? Y(e) : Re(),
      s = Re(l);
  return l || a({
    parent: e,
    node: [Ae({
      from: z,
      target: i
    }), Ae({
      from: "value",
      store: 1,
      target: s
    })],
    family: {
      owners: [e, t, r],
      links: t
    },
    meta: {
      op: o
    },
    regional: 1
  }), u('sampleSource', s, i, n), [i, s];
},
    At = function At(e, t, r, n) {
  var a = e[t];
  a && o({
    target: a,
    params: Array.isArray(a) ? a.map(function () {
      return r;
    }) : r,
    defer: 1,
    stack: n
  });
},
    It = "22.2.0";

export { j as allSettled, y as attach, ft as clearNode, p as combine, b as createApi, v as createDomain, h as createEffect, c as createEvent, a as createNode, d as createStore, m as createStoreObject, q as fork, dt as forward, k as fromObservable, $ as guard, N as hydrate, W as is, o as launch, w as merge, C as restore, S as sample, O as scopeBind, F as serialize, i as setStoreName, M as split, De as step, It as version, pe as withFactory, n as withRegion };